import { Card } from "primereact/card"
import { Button } from "primereact/button"
import './presentationThumbnail.css'
import { Trans, useTranslation } from "react-i18next";
import { WysiwygRenderer } from "../wysiwyg/wysiwygRenderer";
import { useState, useRef, useEffect } from "react";

export const PresentationThumbnail = (props) => {
    const { t } = useTranslation();
    const [expanded, setExpanded] = useState(false);
    const [showToggle, setShowToggle] = useState(false);
    const [contentHeight, setContentHeight] = useState(null);
    const contentRef = useRef(null);

    useEffect(() => {
        // Vérifier la hauteur du contenu après le rendu
        if (contentRef.current) {
            const h = contentRef.current.scrollHeight;
            setContentHeight(h);
            // Afficher le bouton si le contenu dépasse 150px
            setShowToggle(h > 150);
        }
    }, [props.etudiant.presentation]);

    // Note: on supprime le scroll programmatique pour ne pas "suivre" le bouton lorsque l'utilisateur clique.

    return(
        <Card className="presentation-thumbnail-card p-shadow-5">
            <h1 className="vue-candidat-card-title">
                <Trans i18nKey='profile.presentation' />
            </h1>
            <div 
                ref={contentRef}
                // Avant la mesure (contentHeight === null) on force l'état réduit pour éviter le flash où tout le contenu
                // serait visible brièvement. isCollapsed est true quand on est replié ou pas encore mesuré.
                className={`presentation-content ${(!expanded && (showToggle || contentHeight === null)) ? 'presentation-content-collapsed' : 'presentation-content-expanded'}`}
                style={{ maxHeight: (!expanded ? '150px' : (contentHeight ? `${contentHeight}px` : '150px')) }}
            >
                <WysiwygRenderer content={props.etudiant.presentation} />
            </div>
            {!expanded && showToggle && <div className="presentation-fade-overlay"></div>}
            {showToggle && (
                <div className={`presentation-toggle-container ${expanded ? 'presentation-toggle-container--expanded' : 'presentation-toggle-container--collapsed'}`}>
                    <Button 
                        label={expanded ? t('general.see_less') : t('general.see_more')}
                        className="presentation-toggle-btn"
                        onClick={() => setExpanded(!expanded)}
                        text
                    />
                </div>
            )}
        </Card>
    )
}